import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Order} from './order';

@Injectable()
export class OrderService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

/**
   * List all orders which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.orderURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(order : Order) {
    console.log('Push order to insert method of service.');
    order.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(order));
    return this.http.post(this.config.orderURL+"new", JSON.stringify(order), {headers: this.headers});
  }

  public update(order : Order) {
    console.log('Push order to insert method of service.');
    order.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(order));
    return this.http.put(this.config.orderURL+"id/"+order.id, JSON.stringify(order), {headers: this.headers});
  }

  public qryOrder(id : number) {
    return this.http.post(this.config.orderURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete order '+ id);
    return this.http.post(this.config.orderURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/order/order.service.ts